import React from 'react';

import { HandHoldingBagOfMoneyImage } from 'assets/LoansAndCreditResources';
import { CalculatingLoansImage } from 'assets/LoansAndCreditResources';
import { VirusMoneyBagImage } from 'assets/LoansAndCreditResources';
import {
  ResourcesPageContentTitle,
  StyledResourcesCard,
} from 'components/Composite/ResourcesPage/sharedStyles';
import { RESOURCES } from 'constants/urls';

export const LoansAndCreditResourcesContent = () => {
  return (
    <div>
      <ResourcesPageContentTitle>Loans and credit resources</ResourcesPageContentTitle>
      <StyledResourcesCard
        title="Repay your loans early"
        description="Save on interest by prepaying your loans or increasing your monthly instalment"
        toPath={RESOURCES.LOANS_AND_CREDIT.repayYourLoansEarlyPage}
        image={<HandHoldingBagOfMoneyImage />}
      />
      <StyledResourcesCard
        title="Manage your finances better"
        description="Learn about effective money management strategies."
        toPath="https://www.moneysense.gov.sg/taking-stock-of-your-finances/"
        image={<CalculatingLoansImage />}
      />
      <StyledResourcesCard
        title="Tide over this Covid-19 period with temporary relief"
        description="Learn more about the available loan repayment options."
        toPath="https://www.mas.gov.sg/regulation/covid-19/supporting-individuals-through-covid-19/helping-individuals-transit-to-full-loan-repayments"
        image={<VirusMoneyBagImage />}
      />
    </div>
  );
};
